import React, { useState } from 'react';
import { sendEmailVerification } from 'firebase/auth';
import { auth } from '../firebase/config';
import { useAuth } from '../context/AuthContext';
import './VerifyEmailBanner.css';

// Non-blocking reminder shown to signed-in, password-account users who haven't
// clicked the verification link yet. Google accounts arrive pre-verified so
// they never see this.
const VerifyEmailBanner = () => {
  const { currentUser } = useAuth();
  const [status, setStatus] = useState('idle'); // idle | sending | sent | error
  const [dismissed, setDismissed] = useState(false);

  const isPasswordAccount = (currentUser?.providerId || 'password') === 'password';
  const shouldShow = !!currentUser && !currentUser.emailVerified && isPasswordAccount && !dismissed;

  if (!shouldShow) return null;

  const handleResend = async () => {
    if (!auth.currentUser) return;
    setStatus('sending');
    try {
      await sendEmailVerification(auth.currentUser);
      setStatus('sent');
    } catch (e) {
      setStatus('error');
    }
  };

  return (
    <div className="verify-email-banner">
      <span className="verify-email-text">
        Please verify <strong>{currentUser.email}</strong> to secure your account.
      </span>
      <div className="verify-email-actions">
        <button
          type="button"
          className="verify-email-resend"
          onClick={handleResend}
          disabled={status === 'sending' || status === 'sent'}
        >
          {status === 'sending' ? 'Sending…' : status === 'sent' ? 'Email sent ✓' : 'Resend email'}
        </button>
        <button
          type="button"
          className="verify-email-dismiss"
          aria-label="Dismiss"
          onClick={() => setDismissed(true)}
        >
          ×
        </button>
      </div>
      {status === 'error' && <span className="verify-email-error">Couldn't send it — try again shortly.</span>}
    </div>
  );
};

export default VerifyEmailBanner;
